module.exports = __webpack_public_path__ + "img/weddings_13_V.55d519a0.webp";